import { type PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { useSticky } from '@lingoda/hooks';
import { useTheme } from '@lingoda/ui';
import { useHeaderContext } from './HeaderContext';

interface Props {
    headerTheme: 'dark' | 'light';
    height?: number;
}

const lightBackground = 'transparent';

export const HeaderContextInitializer = (props: PropsWithChildren<Props>) => {
    const { setHeaderContext } = useHeaderContext();
    const theme = useTheme();
    const sticky = useSticky();
    const [headerHeight, setHeaderHeight] = useState(0);

    const headerTheme = useMemo(() => {
        const darkThemeBackground = props.headerTheme === 'dark' || sticky;

        return {
            backgroundColor: darkThemeBackground
                ? theme.colors.background.default
                : lightBackground,
            height: props.headerTheme === 'dark' ? headerHeight : 0,
            rawHeight: headerHeight,
            setHeight: setHeaderHeight,
            sticky,
        };
    }, [headerHeight, props.headerTheme, sticky, theme]);

    useEffect(() => {
        setHeaderHeight(props.height || 0);
    }, [props.height]);

    useEffect(() => {
        setHeaderContext(headerTheme);
    }, [headerTheme, setHeaderContext]);

    return <>{props.children}</>;
};
